import { render, staticRenderFns } from "./chefiaValidados.vue?vue&type=template&id=19184435&scoped=true&"
import script from "./chefiaValidados.vue?vue&type=script&lang=js&"
export * from "./chefiaValidados.vue?vue&type=script&lang=js&"
import style0 from "./chefiaValidados.vue?vue&type=style&index=0&id=19184435&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19184435",
  null
  
)

export default component.exports